import React, { useCallback } from 'react'
import { useForm } from 'react-hook-form'
import { useMutation } from 'urql'
import { LogMeInMutation } from './mutation'
import { setAuthorizationToken } from './storage'
import packoorangLoginIllustration from '../../assets/images/packoorangLoginIllustration.png'
import packoorangLogoText from '../../assets/images/packoorangLogoText.svg'

interface LoginForm {
  username: string
  password: string
}

export const StaffLogin: React.FC = () => {
  const { register, handleSubmit } = useForm<LoginForm>()

  const [, executeMutation] = useMutation(LogMeInMutation)

  const onSubmit = useCallback(
    async (data: LoginForm) => {
      const result = await executeMutation(data)

      if (result.error) {
        console.error(result.error)
        return
      }

      if (!result.data?.login) {
        console.error('No data returned')
        return
      }

      const token = result.data.login.token

      if (!token) {
        console.error('No token returned')
        return
      }

      setAuthorizationToken(token)
      window.location.reload()
    },
    [executeMutation]
  )

  return (
    <>
      <div className="flex-col-reverse flex sm:flex-row min-h-full flex-1 bg-gray-50">
        <div className="flex flex-1 flex-col bg-white justify-center px-4 py-12 sm:px-6 lg:flex-none lg:px-20 xl:px-24">
          <div className="mx-auto w-full max-w-sm lg:w-96">
            <div>
              <img
                className="h-6 sm:h-10 w-auto"
                src={packoorangLogoText}
                alt="Your Company"
              />
              <h2 className="mt-8 text-2xl font-bold leading-8 tracking-tight text-gray-900">
                Sign in to your account
              </h2>
            </div>

            <div className="mt-10">
              <div>
                <form className="space-y-6" onSubmit={handleSubmit(onSubmit)}>
                  <div>
                    <label
                      htmlFor="username"
                      className="block text-sm font-medium leading-6 text-gray-900"
                    >
                      Username
                    </label>
                    <div className="mt-2">
                      <input
                        id="username"
                        {...register('username')}
                        className="shadow-sm focus:ring-indigo-500 focus:border-indigo-500 block w-full sm:text-sm border-gray-300 rounded-md"
                        placeholder="foo"
                        autoComplete="username"
                        required
                      />
                    </div>
                  </div>

                  <div>
                    <label
                      htmlFor="password"
                      className="block text-sm font-medium leading-5 text-gray-900"
                    >
                      Password
                    </label>
                    <div className="mt-2">
                      <input
                        id="password"
                        type={'password'}
                        {...register('password')}
                        className="shadow-sm focus:ring-indigo-500 focus:border-indigo-500 block w-full sm:text-sm border-gray-300 rounded-md"
                        placeholder="Your password"
                        autoComplete="current-password"
                        required
                      />
                    </div>
                  </div>

                  <div className="space-y-2">
                    <button
                      type="submit"
                      className="group relative w-full flex justify-center py-2 px-4 border border-transparent text-sm font-medium rounded-md text-white bg-emerald-600 hover:bg-indigo-500"
                    >
                      Sign in
                    </button>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
        <div className="relative flex-1 flex flex-col justify-end items-center pb-0 sm:pb-[10vh] ">
          <img
            className="absolute inset-0 object-cover"
            src={packoorangLoginIllustration}
            alt=""
          />
          <div className={'hidden sm:flex flex-col items-center max-sm:mt-8'}>
            <span className="leading-6 text-base font-semibold text-gray-900">
              Packtrack
            </span>
            <span className={'leading-6 text-gray-700'}>
              A circular economy package tracking application
            </span>
          </div>
        </div>
      </div>
    </>
  )
}
